import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { ApiError } from '@/shared/api/errors';
import { ToastProvider, TooltipProvider } from '@/shared/ui';
import { AuthProvider } from '@/domains/identity/AuthProvider';
import { ReauthDialog } from './shell/ReauthDialog';
import { ThemeProvider } from './shell/ThemeProvider';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Never retry a permission, validation or not-found error — the answer will not change.
        if (error instanceof ApiError && !error.isRetryable) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <ToastProvider>
            <AuthProvider>
              <RouterProvider router={router} />
              <ReauthDialog />
            </AuthProvider>
          </ToastProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
